import router from "../router";
import Vue from "vue";

const Authentification = {
    namespaced: true,
    state: {
        token: window.$cookies.get("token-sudthd") ?
            "Bearer " + window.$cookies.get("token-sudthd") : "",
        status: null,
        drawer: false,
        user: {
            roles: []
        }
    },
    actions: {
        setDrawer(context, value) {
            context.commit("SETDRAWER", value)
        },
        getUserConnected(context) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "userConnected").then(
                    response => {
                        if (typeof response.data.data.id !== "undefined") {
                            context.commit("GETUSERCONNECTED", response.data.data);
                            resolve();
                        } else {
                            Vue.prototype.$awn.alert(
                                "Echec de la récupération de l'utilisateur : " +
                                response.data.message.toString(), {
                                    position: "bottom-right",
                                    timeout: 3000
                                }
                            );
                        }
                    }
                );
            })
        },
        login(context, usercredential) {
            let param = {
                username: usercredential.username,
                password: usercredential.password
            };
            let options = {
                headers: {
                    'content-type': 'application/json'
                },
            }
            Vue.axios.post(window.urlapi + "login", param, options).then(
                response => {

                    if (typeof response.data.token !== "undefined") {
                        Vue.prototype.$awn.success("Connexion réussie !", {
                            position: "bottom-right",
                            timeout: 3000
                        });
                        context.commit("LOGIN", response.data);
                        context.dispatch("getUserConnected");
                    } else {
                        Vue.prototype.$awn.alert(
                            "Echec de la connexion : " + response.data.message.toString(), {
                                position: "bottom-right",
                                timeout: 3000
                            }
                        );
                    }
                },
            ).catch((error) => {
                Vue.prototype.$awn.alert(
                    "Identifiant ou mot de passe erroné", {
                        position: "bottom-right",
                        timeout: 3000
                    }
                );
            });
        },
        logout(context, user) {
            context.commit("LOGOUT", user);
        },
        setdrawer(context, variable) {
            context.commit("SETDRAWER", variable);
        },
        setUserConnected(context, user) {
            context.commit("GETUSERCONNECTED", user);
        }
    },
    mutations: {
        LOGIN: (state, data) => {
            state.status = "success";
            let now = new Date();
            window.$cookies.set("token-sudthd", data.token, {
                expire: now.getTime() * 86400,
                domain: ".clicmap.fr"
            });
            state.token = "Bearer " + data.token;
            Vue.axios.defaults.headers.common["Authorization"] = state.token;
            router.push({ name: "Dossiers" });
        },
        LOGOUT: state => {
            try {
                state.status = "failure";
                window.$cookies.remove("token-sudthd");
                state.token = null;
                state.user = {};
                Vue.axios.defaults.headers.common["Authorization"] = state.token;
                router.push({ name: "Login" });
            } catch (err) {
                Vue.prototype.$awn.alert(
                    "Erreur de deconnexion"
                );
            }
        },
        SETDRAWER: (state, variable) => {
            state.drawer = variable;
        },
        GETUSERCONNECTED: (state, user) => {
            state.user = user;
        }
    },
    getters: {
        token: state => state.token,
        isAuthenticated: state => !!state.token,
        authStatus: state => state.status,
        drawerStatus: state => state.drawer,
        userConnected: state => state.user,
        isUserConnected: state => !!state.user.length,
        isActivated: state => state.user.user_confirm || false
    }
};
export default Authentification;